import { MsalProvider } from '@azure/msal-react'
import { type ReactNode } from 'react'

import { MsalClient } from '@/lib/msal/msal-client'

type MsalAppProviderProps = {
  children: ReactNode
}

export const MsalAppProvider = ({ children }: MsalAppProviderProps) => (
  <MsalProvider instance={MsalClient.getInstance()}>{children}</MsalProvider>
)
